<section class="makePaymentPage__invoicesTable my-4">
  <div class="makePaymentPage__tableHeader container py-3">
    <div class="makePaymentPage__tableHeaderRow row d-none d-lg-flex">
      <div class="makePaymentPage__tableHeaderCell col-2">{{ 'makeAPayment.status' | cxTranslate }}</div>
      <div class="makePaymentPage__tableHeaderCell col-2">{{ 'makeAPayment.invoice#' | cxTranslate }}</div>
      <div class="makePaymentPage__tableHeaderCell col-2">{{ 'makeAPayment.payment_date' | cxTranslate }}</div>
      <div class="makePaymentPage__tableHeaderCell col-3">{{ 'makeAPayment.payment_method' | cxTranslate }}</div>
      <div class="makePaymentPage__tableHeaderCell col-3">{{ 'makeAPayment.payment_amount' | cxTranslate }}</div>
    </div>
  </div>
  <div class="makePaymentPage__tableBody container">
    @for (invoice of paymentResponse()?.creditCardPaymentResponse?.openinvoiceItems || []; track invoice.invoiceNumber) {
      <sanofi-payments-confirmation-invoices-list-row
        [status]="paymentResponse()?.transactionStatus"
        [id]="invoice.invoiceNumber"
        [date]="invoice.dueDate"
        [invoiceItemForPaymentMethod]="invoice"
        [amount]="invoice.payAmount"
      />
    }

    @for (invoice of paymentResponse()?.creditMemoInvoicePaymentResponse || []; track invoice.originalInvoice) {
      <sanofi-payments-confirmation-invoices-list-row
        [status]="paymentResponse()?.transactionStatus"
        [id]="invoice?.rebzg ? invoice?.refDocNo : invoice?.originalInvoice"
        [date]="invoice.entryDate"
        [amount]="invoice.amount"
      />
    }

    <sanofi-no-items-disclaimer
      [itemsList]="paymentResponse()?.creditCardPaymentResponse?.openinvoiceItems || paymentResponse()?.creditMemoInvoicePaymentResponse || []"
      [text]="'makeAPayment.noInvoicesToDisplay' | cxTranslate"
      [mix]="'makePaymentPage__tableRow'"
    />
  </div>
</section>
